import React from "react"
import styled from "styled-components"
import Link from "../components/link"
import { Eject, List, TextRight } from "@styled-icons/bootstrap"
import { below, getFlexJustify, getFlexAlign, Wrapper } from "../styles"

export const NavContainer = styled(
  ({
    justifyStart,
    justifyEnd,
    justifyAround,
    justifyBetween,
    justifyEvenly,
    justifyCenter,
    alignStart,
    alignEnd,
    alignBaseline,
    alignCenter,
    alignStretch,
    row,
    color,
    primary,
    secondary,
    accent,
    grayScale,
    ...rest
  }) => <header {...rest} />
)`
  display: flex;
  flex-direction: ${({ row }) => (row ? "row" : "column")};
  justify-content: ${props => getFlexJustify(props, "space-between")};
  align-items: ${props => getFlexAlign(props, "center")};
  z-index: 2;
  height: 110px;
  width: 1180px;
  margin: 0 auto;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 10px 25px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  background: ${p => p.theme.primaryColor};
  ${below.lg`
    max-width: 960px;
  `};
  ${below.md`
    flex-direction: column;
    align-items: flex-start;
    height: 85px;
    max-width: 720px;
    padding: 8px 15px;
  `};
  ${below.sm`
    max-width: 100%;
  `};
`

export const NavImg = styled.img`
  height: 50px;
  margin: 10px 0 0 0;
  ${below.md`
    height: 50px;
    margin: 8px 0 0 0;
  `};
`

export const NavWrapper = styled(Wrapper)`
  padding: 0;
  margin: 0;
  ${below.md`
    width: 100%;
  `};
`

export const Navbar = styled(
  ({
    justifyStart,
    justifyEnd,
    justifyAround,
    justifyBetween,
    justifyEvenly,
    justifyCenter,
    alignStart,
    alignEnd,
    alignBaseline,
    alignCenter,
    alignStretch,
    row,
    color,
    primary,
    secondary,
    accent,
    grayScale,
    width,
    showNav,
    ...rest
  }) => <div {...rest} />
)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  z-index: 10;
  width: 100%;
  ${below.md`
    flex-direction: ${({ row }) => (row ? "row" : "column")};
    justify-content: ${props => getFlexJustify(props)};
    align-items: ${props => getFlexAlign(props)};
    width: 250px;
    padding: 8px 0;
    position: fixed;
    top: 0;
    bottom: 0;
    right: ${({ showNav }) => (showNav ? "0" : `-253px`)};
    box-shadow: -1px 0px 3px 0px rgba(0,0,0,0.25);
    background-color: rgba(10, 10, 10, 0.97);
    transition: all 0.25s ease-out;
  `};
`

export const NavGreyBack = styled.div`
  z-index: 9;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  display: ${({ showNav }) => (showNav ? "block" : "none")};
`

export const Navs = styled(
  ({
    justifyStart,
    justifyEnd,
    justifyAround,
    justifyBetween,
    justifyEvenly,
    justifyCenter,
    alignStart,
    alignEnd,
    alignBaseline,
    alignCenter,
    alignStretch,
    row,
    ...rest
  }) => <div {...rest} />
)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-right: 25px;
  z-index: 10;
  ${below.md`
    flex-direction: ${({ row }) => (row ? "row" : "column")};
    justify-content: ${props => getFlexJustify(props)};
    align-items: ${props => getFlexAlign(props)};
    margin: 0;
    width: 100%;
  `};
`

const activeClassName = `active`
export const Nav = styled(({ ...rest }) => <Link {...rest} />).attrs({
  activeClassName,
})`
  font-size: 1rem;
  font-weight: 600;
  z-index: 10;
  margin: 0 15px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.6);
  ${below.md`
    margin: 10px 25px;
  `};

  &.${activeClassName}, &:hover {
    color: ${({ theme }) => theme.accentColor};
    transition: all 0.2s ease-in-out;
  }
`
// NAV BAR
export const Burger = styled(List)`
  display: none;
  color: #fff;
  margin-right: 15px;
  cursor: pointer;
  text-align: right;
  height: 30px;
  ${below.md`
    display: block;
  `};
`

export const BurgerOpen = styled(TextRight)`
  display: none;
  color: #fff;
  margin: 15px 20px 10px;
  cursor: pointer;
  height: 30px;
  ${below.md`
    display: block;
  `};
`

export const Triangle = styled(Eject)`
  height: 30px;
  margin-right: 10px;
  padding-bottom: 5px;
  ${below.md`
    height: 25px;
  `};
`

export const Slash = styled.span`
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.8em;
  padding-bottom: 2px;
  ${below.md`
    display: none;
  `};
`

export const Logo = styled.div`
  color: #fff;
  border: 2px solid #fff;
  border-left: none;
  border-right: none;
  font-size: 2em;
  font-weight: 700;
  padding: 5px 10px;
  width: 310px;
  ${below.md`
    font-size: 1.5em;
    width: 240px;
  `};
`

export const Composer = styled.div`
  color: #fff;
  font-size: 1.3em;
  font-weight: 700;
  width: 310px;
  text-align: center;
  margin: 0;
  padding: 0;
  ${below.md`
    width: 240px;
    font-size: 1.2em;
  `};
`
